import { IconButton, Typography } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import { useState } from 'react';
import { ContactsListDialog } from './contacts-list.dialog';
import { GridCountCell } from '../../components/grid-cell-count';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface CellProps {
  count: number;
  customerID?: number;
  officeID?: number;
  projectID?: number;
}

const styling = {
  iconStyle: { color: '$primary-color' },
  textStyle: { paddingLeft: '5px', color: '$primary-color' },
};

export const ContactsCount = ({ count, customerID, officeID, projectID }: CellProps) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleCloseDialog = () => {
    setIsDialogVisible(false);
  };

  const handleCountClick = () => {
    setIsDialogVisible(true);
  };

  const isContactViewPermission = useAuthorize([UserPermissionName.VIEW_CONTACT]);

  return (
    <>
      <GridCountCell
        isDisabled={!isContactViewPermission}
        count={count}
        icon={<GroupIcon style={styling.iconStyle} />}
        onClick={handleCountClick}
      />
      {isDialogVisible && (
        <ContactsListDialog
          customerID={customerID}
          officeID={officeID}
          projectID={projectID}
          open={isDialogVisible}
          onClose={handleCloseDialog}
        />
      )}
    </>
  );
};
